'use client';
// ═══════════════════════════════════════════════════════════════
// AUREUS SOCIAL PRO — PORTE 2FA AU NIVEAU **SESSION**
// ═══════════════════════════════════════════════════════════════
// Incident 05/08/2026 (signalé par le fondateur) : connexion par LIEN MAGIQUE
// → entrée directe dans le dashboard, sans mot de passe ET sans code 2FA.
//
// Cause : le seul contrôle 2FA vivait dans le formulaire de connexion
// (app/(auth)/login.js, branche `signInWithPassword`). Or une session peut
// naître par TROIS autres chemins qui ne passent jamais par ce formulaire :
//   1. lien magique  (signInWithOtp → detectSessionInUrl)
//   2. lien de réinitialisation de mot de passe
//   3. impersonation admin (verifyOtp sur un token_hash)
// … et même par le formulaire, `signInWithPassword` crée la session AVANT
// l'écran TOTP : un simple F5 sur cet écran suffisait à entrer (app/page.js
// relit getSession() et ouvre le dashboard).
//
// Le contrôle doit donc porter sur la SESSION, pas sur le formulaire :
// tant que le niveau d'assurance est aal1 alors que le compte a un facteur
// TOTP vérifié, aucune page applicative ne s'affiche.
//
// Lecture locale : getAuthenticatorAssuranceLevel() décode le claim `aal` du
// JWT et lit `session.user.factors` — aucun appel réseau dans le cas normal.

/**
 * La session courante doit-elle encore franchir le 2e facteur ?
 * @returns {Promise<boolean>} true = afficher la porte TOTP, ne rien ouvrir d'autre
 */
export async function sessionNeedsMFA(supabase) {
  if (!supabase?.auth?.mfa) return false;
  try {
    const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
    if (error || !data) return false;

    const { currentLevel, nextLevel } = data;
    if (!currentLevel) return false;            // pas de session → rien à garder
    if (currentLevel === 'aal2') return false;  // 2e facteur déjà validé
    if (nextLevel === 'aal2') return true;      // facteur vérifié, session encore aal1

    // Repli : `session.user.factors` peut manquer sur une session restaurée
    // depuis le stockage (l'objet user y est parfois tronqué). Dans ce cas
    // SEULEMENT — champ absent, pas tableau vide — on interroge le serveur.
    const { data: sess } = await supabase.auth.getSession();
    if (!sess?.session) return false;
    if (Array.isArray(sess.session.user?.factors)) return false;

    const { data: f, error: fErr } = await supabase.auth.mfa.listFactors();
    if (fErr || !f) return false;
    return (f.totp || []).some((x) => x.status === 'verified');
  } catch {
    // Panne de transport : on n'enferme pas les 36 comptes dehors pour un
    // hoquet réseau. Le chemin nominal ci-dessus est purement local, donc ce
    // repli ne se déclenche que si le client Supabase lui-même est cassé.
    return false;
  }
}
